module.exports = __webpack_public_path__ + "img/hat-banner_4.eec85361.png";